// Hash验证工具函数

export const MD5_HEX_LENGTH = 32;      // MD5十六进制字符串长度
export const SHA256_HEX_LENGTH = 64;   // SHA256十六进制字符串长度

/**
 * 验证 hash 格式是否为有效的 MD5，或 32 字节摘要的十六进制（SHA256 / 国密 SM3，均为 64 个十六进制字符）。
 * @param {string} hash - 要验证的 hash 值
 * @returns {boolean} - 是否为有效的 hash
 */
export function isValidHash(hash) {
  if (!hash || !hash.trim()) return false;
  const trimmedHash = hash.trim();
  
  // 检查是否为十六进制字符串
  const hexPattern = /^[0-9a-fA-F]+$/;
  if (!hexPattern.test(trimmedHash)) return false;
  
  // 检查长度：MD5 为 32 字符；SHA256 / SM3 均为 64 字符
  return trimmedHash.length === MD5_HEX_LENGTH || trimmedHash.length === SHA256_HEX_LENGTH;
}

/**
 * 获取 hash 类型（64 位十六进制无法区分 SHA256 与 SM3，统一标注为二者之一）。
 * @param {string} hash - hash 值
 * @returns {string} - 'MD5'、'SHA256 或 SM3' 或 ''
 */
export function getHashType(hash) {
  if (!hash) return '';
  const trimmed = hash.trim();
  
  if (trimmed.length === MD5_HEX_LENGTH && /^[0-9a-fA-F]+$/.test(trimmed)) {
    return 'MD5';
  }
  if (trimmed.length === SHA256_HEX_LENGTH && /^[0-9a-fA-F]+$/.test(trimmed)) {
    return 'SHA256 或 SM3';
  }
  return '';
}

/**
 * 获取hash格式错误信息
 * @param {string} hash - hash值
 * @returns {string} - 错误信息，如果格式正确则返回空字符串
 */
export function getHashError(hash) {
  if (!hash || !hash.trim()) return '';
  const trimmed = hash.trim();
  if (trimmed.length === 0) return '';
  
  // 检查是否包含非十六进制字符
  if (!/^[0-9a-fA-F]+$/.test(trimmed)) {
    return 'Hash值只能包含0-9和a-f（或A-F）字符';
  }
  
  // 检查长度
  if (trimmed.length !== MD5_HEX_LENGTH && trimmed.length !== SHA256_HEX_LENGTH) {
    return `Hash 长度须为 ${MD5_HEX_LENGTH}（MD5）或 ${SHA256_HEX_LENGTH}（SHA256 / 国密 SM3）个十六进制字符`;
  }
  
  return '';
}
